import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import * as ProcoreIframeHelpers from '@procore/procore-iframe-helpers';
import { AdobeService } from 'src/app/services/adobe.service';
import { ClientService } from 'src/app/services/client.service';
import { ContextService } from 'src/app/services/context.service';
import { ProcoreService } from 'src/app/services/procore.service';

@Component({
	selector: 'app-landing',
	templateUrl: './landing.component.html',
	styleUrls: ['./landing.component.css']
})
export class LandingComponent implements OnInit {
	authError = false;
	authMessage;

	constructor(
		private fb: UntypedFormBuilder,
		private contextService: ContextService,
		private adobeService: AdobeService,
		private clientService: ClientService,
		private procoreService: ProcoreService,
		private router: Router,
		private route: ActivatedRoute
	) { }

	/**
	 * This is the initial component that gets loaded when the page loads.  This component
	 * is responsible for setting the context of the user and the side-panel.
	 * 
	 * The following occurs within this component
	 * 
	 * 1. Load the query parameters to determine if the user is 
	 * 		- initially loading the side-panel, 
	 * 		- just logged in, or 
	 * 		- 
	 * 2. 
	 */

	// 1. https://cool-cat-cd2045.netlify.app					INITIAL SIDE-PANEL LOAD
	// 2. https://cool-cat-cd2045.netlify.app?code=123			POST PROCORE AUTH
	// 3. https://cool-cat-cd2045.netlify.app?code=123&state=	...
	// 4. 

	ngOnInit() {
		this.loadQueryParams();
	}

	loadQueryParams() {
		this.contextService.procoreIsSandbox = document.referrer.indexOf('sandbox') > -1 || document.referrer.indexOf('cool-cat-cd2045.netlify.app') > -1;

		this.route.queryParams.subscribe(params => {
			// Look for the code param and authenticate the user if not present.
			if (params['error'] && params['error_description']) {
				this.authMessage = 'Adobe Sign authentication failed with the following message: ' + params['error_description'] + '. Please  try again and contact support@shakeit.ai if the problem persists.';
			} else if (params['code'] && params['state']) {
				// If there is only a code, the user just signed into Adobe Sign and was redirected back to the app
				this.adobeService.createAdobeUserAuth(params['code'], params['state']).subscribe((result) => {
					// state = email:companyId
					this.authMessage = result;
				});
			} else if (params['code']) {
				// If there is only a code, the user just accepted the Procore auth popup
				console.log('AS - PROCORE AUTHENTICATED: ' + params['code']);
				this.contextService.procoreAuthCode = params['code'];

				const context = ProcoreIframeHelpers.initialize();
				context.authentication.notifySuccess({ code: this.contextService.procoreAuthCode });

				this.loadSidepanelContext();
			} else {
				console.log('AS - ******************************');
				console.log('AS - ADOBE ACROBAT SIGN FOR PROCORE');
				console.log('AS - ******************************');
				console.log('AS - INITIAL PAGE LOAD');
				this.procoreAuth();
			}
		});
	}

	procoreAuth() {
		let url = '';
		let redirectUrl = '';
		if (this.contextService.procoreIsSandbox) {
			console.log('AS - AUTHENTICATE PROCORE: SANDBOX');
			redirectUrl = 'https://cool-cat-cd2045.netlify.app';
			url = 'https://sandbox.procore.com/oauth/authorize?response_type=code&client_id=p0cNe3U-SzQdijBNVJx_G11aiB-j6E1Gra9AImu_7oY&redirect_uri=' + redirectUrl;
		} else {
			console.log('AS - AUTHENTICATE PROCORE: PRODUCTION');
			redirectUrl = 'https://cool-cat-cd2045.netlify.app';
			url = 'https://login.procore.com/oauth/authorize?response_type=code&client_id=DfLh2pIzbJixZVlZL80iyo9hnxs6GuCVDC94ItIS61U&redirect_uri=' + redirectUrl;
		}

		const context = ProcoreIframeHelpers.initialize();
		const _this = this;

		context.authentication.authenticate({
			url: url,
			onSuccess: function (payload) {
				window.location.href = redirectUrl + '?code=' + payload.code;
			},
			onFailure: function (error) {
				console.log('AS - PROCORE AUTH FAILED: error');
				_this.authError = true;
			}
		});
	}

	// At this point we have the code only
	loadSidepanelContext() {
		window.addEventListener('message', (event) => {
			if (event.data.context) {
				this.contextService.procoreContextObject = event.data;
				console.log('AS - SET SIDE-PANEL CONTEXT: ');
				console.log(this.contextService.procoreContextObject);

				this.procoreService.getUserInfo(this.contextService.procoreContextObject.context.company_id, this.contextService.procoreAuthCode, this.contextService.procoreIsSandbox)
					.subscribe((userInfo: any) => {
						this.contextService.procoreUserInfo = userInfo;
						console.log('AS - SET USER INFO:');
						console.log(this.contextService.procoreUserInfo);

						this.clientService.getClientDetailProcoreByCompanyId(this.contextService.procoreContextObject.context.company_id, this.contextService.procoreContextObject.context.project_id)
							.subscribe((clientDetailProcore: any) => {

								if (!clientDetailProcore) {
									console.log('AS - NO CLIENT DETAIL PROCORE, NAVIGATE TO WELCOME');
									this.router.navigate(['/welcome']);
								} else {
									console.log('AS - SET CLIENT DETAIL PROCORE:');
									console.log(clientDetailProcore);
									this.contextService.clientDetailProcore = clientDetailProcore;

									if (clientDetailProcore.adobeAccountType) {
										console.log('AS - NAVIGATE TO WELCOME AUTHENTICATE');
										this.router.navigate(['/welcome/authenticate']);
									} else {
										console.log('AS - NAVIGATE TO WELCOME CONFIGURE');
										this.router.navigate(['/welcome/configure']);
									}
								}
							});
					});
			}
		});

		window.parent.postMessage({ type: 'initialize' }, '*');
	}
}
